import { useContext } from 'react';
import { ServiceStatusContext } from './ServiceStatusProvider';
import { ServiceName, ServiceStatusContextType } from './types';

export function useServiceStatus(): ServiceStatusContextType {
  const context = useContext(ServiceStatusContext);

  if (context === null) {
    throw new Error('useServiceStatus must be used within a ServiceStatusProvider');
  }

  return context;
}

export function useServiceCheck(services: ServiceName[]): {
  allOnline: boolean;
  anyOffline: boolean;
  offlineServices: ServiceName[];
  isChecking: boolean;
} {
  const { status } = useServiceStatus();

  const offlineServices = services.filter(service => status[service] === 'offline');
  const allOnline = services.every(service => status[service] === 'online');
  const anyOffline = offlineServices.length > 0;
  const isChecking = services.some(service => status[service] === 'checking');

  return {
    allOnline,
    anyOffline,
    offlineServices,
    isChecking,
  };
}
